import React, { useState, useEffect } from "react";
import "../CreateLoan/createLoan.css";
import RegisterTextbox from "../../components/RegisterTextBox";
import Title from "../../components/title";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBank,
  faDatabase,
  faGraduationCap,
  faFileContract,
  faNotesMedical,
  faPeopleRoof,
  faPersonHarassing,
  faPhoneVolume,
  faPlus,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import "./addBeneficiary.css";
import RegisterSelect from "../../components/RegisterSelect";
import UploadInput from "../../components/UploadInput";
import RegisterRadio from "../../components/Radio";
import API from "../../api/axiosConfig";
import TestPreLoader from "../TestPreLoader/TestPreLoader";
import { useNavigate, useParams } from "react-router";
import CustomTable from "../../components/CustomTable";
import RegisterTextarea from "../../components/RegisterTextarea";

import dayjs from "dayjs";

function CaseStudy() {
  const tabs = [
    "beneficiary",
    "mainbeneficiarydata",
    "bankdata",
    "qualificationposition",
    "housingdata",
    "healthdata",
    "dependentsdata",
    "Decision",
  ];
  const [activeTab, setActiveTab] = useState("beneficiary");
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [error, setError] = useState([]);
  const { id } = useParams();
  const [decision, setDecision] = useState("");
  const [note, setNote] = useState("");
  const navigate = useNavigate();
  const getAllData = async () => {
    try {
      const res = await API.get(`/humancasedetails/get/${id}`);
      // const data = await res;
      // if (data.status === 200) {
      if (res.status === 200) {
        // setRows(data.data);
        setRows(res.data);
        

        setLoading(false);
        console.log(rows.details.bankdetails_upload);
      }
    } catch (error) {
      console.error(error);
      // setError(error.response.data.errors);
      setError(error.response?.data?.errors);
    }
  };

  const handleDecision = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("id", id);
    formData.append("decision", decision);
    formData.append("note", note);
    try {
      const res = await API.post("/humancases/update/status", formData);
      // const data = await res;
      // if (data.status === 200) {
      if (res.status === 200) {
        navigate("/beneficiary");
      }
    } catch (error) {
      console.error(error);
      // setError(error.response.data.errors);
      setError(error.response?.data?.errors);
    }
  };

  useEffect(() => {
    getAllData();
  }, []);
  const handleNext = () => {
    const currentIndex = tabs.indexOf(activeTab);
    if (currentIndex < tabs.length - 1) {
      setActiveTab(tabs[currentIndex + 1]);
    }
  };

  const handleBack = () => {
    const currentIndex = tabs.indexOf(activeTab);
    if (currentIndex > 0) {
      setActiveTab(tabs[currentIndex - 1]);
    }
  };

  const [dob, setDob] = useState(null);
  const [age, setAge] = useState("");

  const handleDobChange = (newValue) => {
    setDob(newValue);

    if (newValue) {
      const birthDate = dayjs(newValue);
      const today = dayjs();
      let calculatedAge = today.year() - birthDate.year();

      if (
        today.month() < birthDate.month() ||
        (today.month() === birthDate.month() && today.date() < birthDate.date())
      ) {
        calculatedAge--;
      }

      setAge(calculatedAge);
    } else {
      setAge("");
    }
  };

  const [cardNum, setCardNum] = useState("");
  const [mobileNum, setMobileNum] = useState("");
  const [errors, setErrors] = useState({});

  const [dobMap, setDobMap] = useState({});
  const [ageMap, setAgeMap] = useState({});

  const handleDobChange2 = (id, newValue) => {
    setDobMap((prev) => ({ ...prev, [id]: newValue }));

    if (newValue) {
      const birthDate = dayjs(newValue);
      const today = dayjs();
      let calculatedAge = today.year() - birthDate.year();

      if (
        today.month() < birthDate.month() ||
        (today.month() === birthDate.month() && today.date() < birthDate.date())
      ) {
        calculatedAge--;
      }

      setAgeMap((prev) => ({ ...prev, [id]: calculatedAge }));
    } else {
      setAgeMap((prev) => ({ ...prev, [id]: "" }));
    }
  };

  // const [healthStatus, setHealthStatus] = useState('');
  const [illnesses, setIllnesses] = useState([{ id: 1 }]);
  const [dependents, setDependents] = useState([{ id: 1 }]);
  const [housingExpenses, setHousingExpenses] = useState([{ id: 1 }]);

  const handleAddHousingExpense = () => {
    setHousingExpenses([
      ...housingExpenses,
      { id: housingExpenses.length + 1 },
    ]);
  };

  // const handleRadioChange = (value) => {
  //     setHealthStatus(value);
  // };

  // const handleAddIllness = () => {
  //     setIllnesses([...illnesses, { id: illnesses.length + 1 }]);
  // };

  // const handleAddDependent = () => {
  //     setDependents([...dependents, { id: dependents.length + 1 }]);
  // };

  const [incomeSources, setIncomeSources] = useState([{ id: 1 }]);

  const [trainingCourses, setTrainingCourses] = useState([{ id: 1 }]);

  const handleAddIncomeSource = () => {
    setIncomeSources([...incomeSources, { id: incomeSources.length + 1 }]);
  };

  const handleAddTrainingCourse = () => {
    setTrainingCourses([
      ...trainingCourses,
      { id: trainingCourses.length + 1 },
    ]);
  };
  const renderContent = () => {
    switch (activeTab) {
      case "beneficiary":
        return (
          <>
            <div className="AddBeneficiary">
              <Title
                title="بيانات مستفيد"
                icon={<FontAwesomeIcon icon={faPersonHarassing} />}
              />
              <div className="AddBeneficiaryContainer">
                <div className="AddBeneficiaryContainerRow">
                  <RegisterTextbox
                    parentStyle={{
                      width: "30%",
                    }}
                    id="benName"
                    label="إسم المستفيد"
                    type="text"
                    stylee={{
                      width: "40%",
                    }}
                    value={rows && rows.case && rows.case.name}
                    disabled
                  />
                  <RegisterSelect
                    id="fileStatus"
                    label="حالة المستفيد"
                    stylee={{ width: "40%" }}
                    parentStyle={{ width: "30%" }}
                    options={[
                      { value: "", label: "اختر الحالة" },
                      { value: "1", label: "مستفيد مؤقت" },
                      { value: "2", label: "مستفيد دائم" },
                    ]}
                    value={rows && rows.case && rows.case.type}
                    disabled
                  />
                </div>

                <div className="AddBeneficiaryContainerRow">
                  <RegisterTextbox
                    disabled={true}
                    parentStyle={{
                      width: "30%",
                    }}
                    id="createdBy"
                    label="انشأ بواسطة"
                    type="text"
                    stylee={{
                      width: "40%",
                    }}
                    value={
                      rows &&
                      rows.case &&
                      rows.case.details &&
                      rows.case.details.email
                    }
                    readOnly
                  />{" "}
                  <RegisterTextbox
                    parentStyle={{
                      width: "30%",
                    }}
                    id="updateDate"
                    label="تاريخ التحديث"
                    type="text"
                    stylee={{
                      width: "40%",
                    }}
                    value={
                      rows &&
                      rows.case &&
                      new Date(rows.case.updated_at).toISOString().substr(0, 10)
                    }
                    disabled
                  />{" "}
                </div>
                <div className="AddBeneficiaryContainerRow">
                  <RegisterTextbox
                    disabled={true}
                    parentStyle={{
                      width: "30%",
                    }}
                    id="happendby"
                    label="حدث بواسطة"
                    type="text"
                    stylee={{
                      width: "40%",
                    }}
                    value={
                      rows &&
                      rows.case &&
                      rows.case.details &&
                      rows.case.details.email
                    }
                    readOnly
                  />{" "}
                  <RegisterTextbox
                    parentStyle={{
                      width: "30%",
                    }}
                    id="createDate"
                    label="تاريخ الإنشاء"
                    type="text"
                    stylee={{
                      width: "40%",
                    }}
                    value={
                      rows &&
                      rows.case &&
                      new Date(rows.case.created_at).toISOString().substr(0, 10)
                    }
                    disabled
                  />{" "}
                </div>
              </div>
            </div>
          </>
        );
      case "mainbeneficiarydata":
        return (
          <>
            <div className="AddBeneficiary">
              <Title
                title="البيانات الاساسية"
                icon={<FontAwesomeIcon icon={faDatabase} />}
              />
              <div className="AddBeneficiaryContainer">
                <div className="AddBeneficiaryContainerRow">
                  <RegisterTextbox
                    parentStyle={{
                      width: "20%",
                    }}
                    id="name"
                    label="الإسم"
                    type="text"
                    stylee={{
                      width: "40%",
                    }}
                    value={rows && rows.case && rows.case.name}
                    disabled
                  />{" "}
                  <RegisterSelect
                    id="sex"
                    label="النوع"
                    stylee={{ width: "30%" }}
                    parentStyle={{ width: "20%", marginBottom: "20px" }}
                    options={[
                      { value: "", label: "اختر النوع" },
                      { value: "0", label: "ذكر" },
                      { value: "1", label: "أنثي" },
                    ]}
                    value={rows && rows.case && rows.case.gender}
                    disabled
                  />
                </div>
                <div className="AddBeneficiaryContainerRow">
                  <RegisterTextbox
                    parentStyle={{ width: "20%" }}
                    id="dob"
                    label="تاريخ الميلاد"
                    type="text"
                    stylee={{ width: "40%" }}
                    value={rows && rows.case && rows.case.dateofbirth}
                    disabled
                  />
                  <RegisterSelect
                    id="relation"
                    label="الحالة الإجتماعية"
                    stylee={{ width: "30%" }}
                    parentStyle={{ width: "20%", marginBottom: "20px" }}
                    options={[
                      { value: "", label: "اختر الحالة الإجتماعية" },
                      { value: "0", label: "أعزب" },
                      { value: "1", label: "متزوج" },
                      { value: "2", label: "مطلق" },
                      { value: "3", label: "أرمل" },
                    ]}
                    value={rows && rows.case && rows.case && rows.case.status}
                    disabled
                  />
                </div>
                <div className="AddBeneficiaryContainerRow">
                  <RegisterTextbox
                    parentStyle={{
                      width: "20%",
                    }}
                    id="nationality"
                    label="الجنسية"
                    type="text"
                    stylee={{
                      width: "40%",
                    }}
                    value={
                      rows &&
                      rows.case &&
                      rows.case.details &&
                      rows.case.details.nationality
                    }
                  />{" "}
                  <RegisterTextbox
                    parentStyle={{
                      width: "20%",
                    }}
                    id="idnum"
                    label="رقم الهوية"
                    type="number"
                    stylee={{
                      width: "40%",
                    }}
                    value={
                      rows &&
                      rows.case &&
                      rows.case.details &&
                      rows.case.details.id_number
                    }
                    disabled
                  />{" "}
                </div>
                <div className="AddBeneficiaryContainerRow">
                  <RegisterTextbox
                    parentStyle={{
                      width: "20%",
                    }}
                    id="phoneNum"
                    label="رقم الجوال"
                    type="number"
                    stylee={{
                      width: "40%",
                    }}
                    value={
                      rows &&
                      rows.case &&
                      rows.case.details &&
                      rows.case.details.phone_number
                    }
                    disabled
                  />{" "}
                  <RegisterTextbox
                    parentStyle={{
                      width: "20%",
                    }}
                    id="email"
                    label="البريد الإلكتروني"
                    type="email"
                    stylee={{
                      width: "40%",
                    }}
                    value={
                      rows &&
                      rows.case &&
                      rows.case.details &&
                      rows.case.details.email
                    }
                    disabled
                  />{" "}
                </div>
                <div className="AddBeneficiaryContainerRow">
                  <RegisterTextbox
                    parentStyle={{
                      width: "20%",
                    }}
                    id="accNumber"
                    label="رقم الحساب"
                    type="text"
                    stylee={{
                      width: "40%",
                    }}
                    value={
                      rows &&
                      rows.case &&
                      rows.case.details &&
                      rows.case.details.account_number
                    }
                    disabled
                  />{" "}
                  <RegisterTextbox
                    parentStyle={{
                      width: "20%",
                    }}
                    id="idSource"
                    label="مصدر الهوية"
                    type="text"
                    stylee={{
                      width: "40%",
                    }}
                    value={
                      rows &&
                      rows.case &&
                      rows.case.details &&
                      rows.case.details.id_number
                    }
                    disabled
                  />{" "}
                </div>
                <div className="AddBeneficiaryContainerRow">
                  <RegisterTextbox
                    parentStyle={{
                      width: "20%",
                    }}
                    id="idDate"
                    label="تاريخ انتهاء الهوية"
                    type="text"
                    stylee={{
                      width: "40%",
                    }}
                    value={
                      rows &&
                      rows.case &&
                      rows.case.details &&
                      rows.case.details.id_expiration_date
                    }
                    disabled
                  />{" "}
                  <RegisterTextbox
                    parentStyle={{
                      width: "20%",
                    }}
                    id="moreNotes"
                    label="ملاحظات اضافية"
                    type="text"
                    stylee={{
                      width: "40%",
                    }}
                    value={
                      rows &&
                      rows.case &&
                      rows.case.details &&
                      rows.case.details.note
                    }
                    disabled
                  />{" "}
                </div>
              </div>
            </div>
          </>
        );
      case "bankdata":
        return (
          <>
            <div className="AddBeneficiary">
              <Title
                title="البيانات البنكية"
                icon={<FontAwesomeIcon icon={faBank} />}
              />
              <div className="AddBeneficiaryContainer">
                {rows && rows.details && rows.details.bankdetails !== null ? (
                  <>
                    <div className="AddBeneficiaryContainerRow">
                      <RegisterTextbox
                        parentStyle={{
                          width: "30%",
                        }}
                        id="bankName"
                        label="إسم البنك"
                        type="text"
                        stylee={{
                          width: "40%",
                        }}
                        value={
                          rows && rows.details && rows.details.bankdetails
                            ? rows.details.bankdetails.name
                            : "لا يوجد بيانات حاليا"
                        }
                        disabled
                      />{" "}
                    </div>

                    <div className="AddBeneficiaryContainerRow">
                      <RegisterTextbox
                        parentStyle={{
                          width: "30%",
                        }}
                        id="branch"
                        label="الفرع"
                        type="text"
                        stylee={{
                          width: "40%",
                        }}
                        value={
                          rows &&
                          rows.details &&
                          rows.details.bankdetails &&
                          rows.details.bankdetails.branch
                            ? rows.details.bankdetails.branch
                            : "لا يوجد بيانات حاليا"
                        }
                        disabled
                      />{" "}
                    </div>
                    <div className="AddBeneficiaryContainerRow">
                      <RegisterTextbox
                        parentStyle={{
                          width: "30%",
                        }}
                        id="ibanNum"
                        label="رقم IBAN"
                        type="text"
                        stylee={{
                          width: "40%",
                        }}
                        value={
                          rows &&
                          rows.details &&
                          rows.details.bankdetails &&
                          rows.details.bankdetails.iban
                            ? rows.details.bankdetails.iban
                            : "لا يوجد بيانات حاليا"
                        }
                        disabled
                      />{" "}
                    </div>

                    <div
                      className="d-flex justify-content-center flex-column text-end mt-3 m-auto"
                      style={{ width: "30%" }}
                    >
                      <h6>صورة بيانات البنك</h6>
                      <div
                        style={{
                          width: "100%",
                          margin: "10px auto 5px",
                          textAlign: "center",
                          border: "3px solid var(--border-color)",
                          borderRadius: "10px",
                          padding: "20px",
                        }}
                      >
                        {rows?.details?.bankdetails_upload ? (
                          <img
                            src={rows.details.bankdetails_upload}
                            alt="صورة بيانات البنك"
                            style={{
                              maxWidth: "100%",
                              height: "auto",
                              borderRadius: "10px",
                            }}
                          />
                        ) : (
                          <h4 style={{ color: "var(--text-color)" }}>
                            لا توجد صورة حالياً
                          </h4>
                        )}
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <h3
                      style={{
                        textAlign: "center",
                        color: "var(--text-color)",
                      }}
                    >
                      لا يوجد بيانات حاليا
                    </h3>
                  </>
                )}
              </div>
            </div>
          </>
        );
      case "qualificationposition":
        return (
          <>
            <div className="AddBeneficiary">
              <Title
                title="المؤهل والوظيفة"
                icon={<FontAwesomeIcon icon={faGraduationCap} />}
              />
              {rows && rows.work_education !== null ? (
                <>
                  <div className="AddBeneficiaryContainer">
                    <h3 style={{ marginRight: "10%", fontSize: "20px" }}>
                      المؤهلات والوظائف
                    </h3>
                    <table
                      style={{
                        width: "80%",
                        margin: "auto",
                        marginBottom: "40px",
                        direction: "rtl",
                        textAlign: "center",
                        borderCollapse: "collapse",
                        padding: "20px",
                      }}
                      className="styledTable"
                    >
                      <tr style={{ margin: "20px" }}>
                        <th>المؤهل</th>
                        <th>الوظيفة</th>
                        <th>يستطيع العمل</th>
                      </tr>
                      <tr>
                        <td>
                          {rows &&
                            rows.work_education &&
                            rows.work_education.educationlevel}
                        </td>
                        <td>
                          {rows &&
                            rows.work_education &&
                            rows.work_education.job}
                        </td>
                        <td>
                          {rows &&
                          rows.work_education &&
                          rows.work_education.canwork == 0
                            ? "لا"
                            : "نعم"}
                        </td>
                      </tr>
                    </table>
                    <h3 style={{ marginRight: "10%", fontSize: "20px" }}>
                      الدخل
                    </h3>
                    <table
                      style={{
                        width: "80%",
                        margin: "auto",
                        marginBottom: "40px",
                        direction: "rtl",
                        textAlign: "center",
                        borderCollapse: "collapse",
                        padding: "20px",
                      }}
                      className="styledTable"
                    >
                      <tr style={{ margin: "20px" }}>
                        <th>مصدر الدخل</th>
                        <th>الراتب</th>
                        <th>مرفق الدخل</th>
                      </tr>
                      {rows &&
                      rows.work_education &&
                      rows.work_education.incomesource &&
                      rows.work_education.incomesource.length > 0 ? (
                        rows.work_education.incomesource.map(
                          (income, index) => (
                            <tr key={index}>
                              <td>{income.name}</td>
                              <td>{income.amount}</td>
                              <td className="d-flex justify-content-center">
                                <div style={{ maxWidth: "100px" }}>
                                  {rows?.details?.bankdetails_upload ? (
                                    <img
                                      src={
                                        rows.work_education.incomesource_upload
                                      }
                                      alt="صورة بيانات البنك"
                                      style={{
                                        maxWidth: "100%",
                                        height: "auto",
                                        borderRadius: "10px",
                                      }}
                                    />
                                  ) : (
                                    <h4 style={{ color: "var(--text-color)" }}>
                                      لا توجد صورة حالياً
                                    </h4>
                                  )}
                                </div>
                              </td>
                            </tr>
                          )
                        )
                      ) : (
                        <tr>
                          <td
                            colSpan="2"
                            style={{
                              textAlign: "center",
                              fontSize: "20px",
                              color: "var(--text-color)",
                              margin: "20px",
                            }}
                          >
                            لا يوجد بيانات حاليا
                          </td>
                        </tr>
                      )}
                    </table>
                    <h3 style={{ marginRight: "10%", fontSize: "20px" }}>
                      الدورات التدريبية
                    </h3>
                    <table
                      style={{
                        width: "80%",
                        margin: "auto",
                        marginBottom: "40px",
                        direction: "rtl",
                        textAlign: "center",
                        borderCollapse: "collapse",
                        padding: "20px",
                      }}
                      className="styledTable"
                    >
                      <tr style={{ margin: "20px" }}>
                        <th>اسم الدورة</th>
                        <th>مكان الحصول عليها</th>
                        <th>صورة الدورة التدريبية</th>
                      </tr>

                      {rows &&
                      rows.work_education &&
                      rows.work_education.courses &&
                      rows.work_education.courses.length > 0 ? (
                        rows.work_education.courses.map((training, index) => (
                          <tr key={index}>
                            <td>{training.title}</td>
                            <td>{training.address}</td>

                            <td className="d-flex justify-content-center">
                              <div style={{ maxWidth: "100px" }}>
                                {rows?.details?.bankdetails_upload ? (
                                  <img
                                    src={rows.work_education.courses_upload}
                                    alt="صورة بيانات البنك"
                                    style={{
                                      maxWidth: "100%",
                                      height: "auto",
                                      borderRadius: "10px",
                                    }}
                                  />
                                ) : (
                                  <h4 style={{ color: "var(--text-color)" }}>
                                    لا توجد صورة حالياً
                                  </h4>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="2"
                            style={{
                              textAlign: "center",
                              fontSize: "20px",
                              color: "red",
                              margin: "20px",
                            }}
                          >
                            لا يوجد بيانات حاليا
                          </td>
                        </tr>
                      )}
                    </table>
                  </div>
                </>
              ) : (
                <>
                  <h3 style={{ textAlign: "center", color: "red" }}>
                    لا يوجد بيانات حاليا
                  </h3>
                </>
              )}
            </div>
          </>
        );
      case "housingdata":
        return (
          <>
            <div className="AddBeneficiary">
              <Title
                title="بيانات السكن"
                icon={<FontAwesomeIcon icon={faPeopleRoof} />}
              />
              {console.log(rows)}
              {rows && rows.details && rows.details.personalfeesdetails && rows.details.personalfeesdetails.length > 0 ? (
                <>
                  <div className="AddBeneficiaryContainerRow ">
                    <RegisterTextbox
                      parentStyle={{
                        width: "30%",
                      }}
                      id="state"
                      label="القطاع (المحافظة)"
                      type="text"
                      stylee={{
                        width: "40%",
                      }}
                      value={
                        rows &&
                        rows.details &&
                        rows.details.personalfeesdetails &&
                        rows.details.personalfeesdetails.state
                      }
                      disabled
                    />{" "}
                    <RegisterTextbox
                      parentStyle={{
                        width: "30%",
                      }}
                      id="village"
                      label="القرية (الحي)"
                      type="text"
                      stylee={{
                        width: "40%",
                      }}
                      value={
                        rows &&
                        rows.details &&
                        rows.details.personalfeesdetails &&
                        rows.details.personalfeesdetails.village
                      }
                      disabled
                    />{" "}
                  </div>
                  <div className="AddBeneficiaryContainerRow">
                    <RegisterTextbox
                      parentStyle={{
                        width: "30%",
                      }}
                      id="nationalAdress"
                      label="العنوان الوطني"
                      type="text"
                      stylee={{
                        width: "40%",
                      }}
                      value={
                        rows &&
                        rows.details.personalfeesdetails &&
                        rows.details.personalfeesdetails.nationalAddress
                      }
                      disabled
                    />{" "}
                    <RegisterTextbox
                      parentStyle={{
                        width: "30%",
                      }}
                      id="summaryadress"
                      label="العنوان المختصر"
                      type="text"
                      stylee={{
                        width: "40%",
                      }}
                      value={
                        rows &&
                        rows.details.personalfeesdetails &&
                        rows.details.personalfeesdetails.summaryAddress
                      }
                      disabled
                    />{" "}
                  </div>
                  <div className="AddBeneficiaryContainerRow">
                    <RegisterTextbox
                      parentStyle={{
                        width: "30%",
                      }}
                      id="summaryadress"
                      label="نوع السكن "
                      type="text"
                      stylee={{
                        width: "40%",
                      }}
                      value={
                        rows &&
                        rows.details.personalfeesdetails &&
                        rows.details.personalfeesdetails.homeType
                      }
                      disabled
                    />
                    <RegisterTextbox
                      parentStyle={{
                        width: "30%",
                      }}
                      id="ownership"
                      label="ملكية السكن"
                      type="text"
                      stylee={{
                        width: "40%",
                      }}
                      value={
                        rows &&
                        rows.details.personalfeesdetails &&
                        rows.details.personalfeesdetails.homeOwnership
                      }
                      disabled
                    />
                  </div>
                  <div className="AddBeneficiaryContainerRow">
                    <RegisterTextbox
                      parentStyle={{
                        width: "30%",
                      }}
                      id="month"
                      label="الإيجار الشهري للسكن"
                      type="number"
                      stylee={{
                        width: "40%",
                      }}
                      value={
                        rows &&
                        rows.details.personalfeesdetails &&
                        rows.details.personalfeesdetails.rent
                      }
                      disabled
                    />
                    <RegisterTextbox
                      parentStyle={{
                        width: "30%",
                      }}
                      id="cars"
                      label="عدد السيارات المملوكة"
                      type="number"
                      stylee={{
                        width: "40%",
                      }}
                      value={
                        rows &&
                        rows.details.personalfeesdetails &&
                        rows.details.personalfeesdetails.cars
                      }
                      disabled
                    />
                  </div>

                  <div className="AddBeneficiaryContainerRow">
                    <RegisterTextbox
                      parentStyle={{
                        width: "30%",
                      }}
                      id="lands"
                      label="عدد الأراضي المملوكة"
                      type="number"
                      stylee={{
                        width: "40%",
                      }}
                      value={
                        rows &&
                        rows.details.personalfeesdetails &&
                        rows.details.personalfeesdetails.lands
                      }
                      disabled
                    />
                    <RegisterTextbox
                      parentStyle={{
                        width: "30%",
                      }}
                      id="components"
                      label="مكونات السكن"
                      type="text"
                      stylee={{
                        width: "40%",
                      }}
                      value={
                        rows &&
                        rows.details.personalfeesdetails &&
                        rows.details.personalfeesdetails.components
                      }
                      disabled
                    />
                  </div>
                  <div className="AddBeneficiaryContainerRow">
                    <RegisterTextbox
                      parentStyle={{
                        width: "30%",
                      }}
                      id="furniture"
                      label="اثاث الشقة"
                      type="text"
                      stylee={{
                        width: "40%",
                      }}
                      value={
                        rows &&
                        rows.details.personalfeesdetails &&
                        rows.details.personalfeesdetails.furniture
                      }
                      disabled
                    />
                    <RegisterTextbox
                      parentStyle={{
                        width: "30%",
                      }}
                      id="personperMonth"
                      label="تكاليف الشهر للفرد"
                      type="text"
                      stylee={{
                        width: "40%",
                      }}
                      value={
                        rows &&
                        rows.details.personalfeesdetails &&
                        rows.details.personalfeesdetails.cost
                      }
                      disabled
                    />
                  </div>

                  <h3
                    style={{
                      direction: "rtl",
                      marginRight: "12%",
                      marginTop: "30px",
                    }}
                  >
                    {" "}
                    مصروفات السكن{" "}
                  </h3>
                  <table
                    style={{
                      width: "75%",
                      margin: "auto",
                      direction: "rtl",
                      textAlign: "center",
                      borderCollapse: "collapse",
                      padding: "20px",
                    }}
                    className="styledTable"
                  >
                    <tr>
                      <th> الفاتورة الشهرية</th>
                      <th>القيمة</th>
                    </tr>

                    {rows &&
                    rows.details.personalfeesdetails &&
                    JSON.parse(rows.details.personalfeesdetails.bill) &&
                    JSON.parse(rows.details.personalfeesdetails.bill).length >
                      0 ? (
                      JSON.parse(rows.details.personalfeesdetails.bill).map(
                        (bill, index) => (
                          <tr key={index}>
                            <td>{bill.bill}</td>
                            <td>{bill.amount}</td>
                          </tr>
                        )
                      )
                    ) : (
                      <tr>
                        <td
                          colSpan="2"
                          style={{
                            textAlign: "center",
                            fontSize: "20px",
                            color: "var(--text-color)",
                            margin: "20px",
                          }}
                        >
                          لا يوجد بيانات حاليا
                        </td>
                      </tr>
                    )}
                  </table>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "space-evenly",
                      alignItems: "center",
                      marginTop: "20px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginTop: "20px",
                        width: "60%",
                      }}
                    >
                      {rows.details.personalfeesdetails_upload1 &&
                      rows.details.personalfeesdetails_upload1 !== "" ? (
                        <h5>صورة ملكية السكن </h5>
                      ) : (
                        <h5>لا توجد صورة لملكية السكن </h5>
                      )}

                      {rows.details.personalfeesdetails_upload2 &&
                      rows.details.personalfeesdetails_upload2 !== "" ? (
                        <a
                          href={rows.details.personalfeesdetails_upload1}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FontAwesomeIcon icon={faEye} />
                        </a>
                      ) : null}
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginTop: "20px",
                      }}
                    >
                      {rows.details.personalfeesdetails_upload1 &&
                      rows.details.personalfeesdetails_upload1 !== "" ? (
                        <h5>صورة فاتورة الكهرباء</h5>
                      ) : (
                        <h5>لا توجد صورة لفاتورة الكهرباء </h5>
                      )}
                      {rows.details.personalfeesdetails_upload2 &&
                      rows.details.personalfeesdetails_upload2 !== "" ? (
                        <a
                          href={rows.details.personalfeesdetails_upload2}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FontAwesomeIcon icon={faEye} />
                        </a>
                      ) : null}
                    </div>
                  </div>
                </>
              ) : (
                <div className="message-container">
                  <p
                    style={{
                      textAlign: "center",
                      fontSize: "25px",
                      color: "red",
                      margin: "30px",
                    }}
                  >
                    لا يوجد بيانات حاليا
                  </p>
                </div>
              )}
            </div>
          </>
        );
      case "healthdata":
        return (
          <>
            <div className="AddBeneficiary">
              <Title
                title="البيانات الصحية"
                icon={<FontAwesomeIcon icon={faNotesMedical} />}
              />

              <>
                <div className="duplicatedContent">
                  <table
                    className="vac-custom-table"
                    style={{ width: "80%", margin: "auto", marginTop: "50px" }}
                  >
                    <thead>
                      <tr className="vac-table-header selected-row">
                        <th>اسم المرض</th>
                        <th>نوع المرض</th>
                        <th>خطورة المرض</th>
                        <th>نوع العلاج</th>
                        <th>تكلفة العلاج</th>
                        <th>ملاحظات</th>
                        <th>صورة التقرير الصحية</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows.health.length > 0 ? (
                        rows.health.map((illness) => (
                          <tr key={illness.id} className="selected-row">
                            <td>
                              <RegisterTextbox
                                id={`name-${illness.id}`}
                                type="text"
                                stylee={{ width: "100%" }}
                                value={illness.disease_name}
                                disabled
                              />
                            </td>
                            <td>
                              <RegisterTextbox
                                id={`type-${illness.id}`}
                                // label="نوع المرض"
                                type="text"
                                stylee={{ width: "100%" }}
                                value={illness.disease_type}
                                disabled
                              />
                            </td>
                            <td>
                              <RegisterTextbox
                                id={`danger-${illness.id}`}
                                // label="خطورة المرض"
                                type="text"
                                stylee={{ width: "100%" }}
                                value={illness.disease_degree}
                                disabled
                              />
                            </td>
                            <td>
                              <RegisterTextbox
                                id={`midtype-${illness.id}`}
                                // label="نوع العلاج"
                                type="text"
                                stylee={{ width: "100%" }}
                                value={illness.treatment_type}
                                disabled
                              />
                            </td>
                            <td>
                              <RegisterTextbox
                                id={`cost-${illness.id}`}
                                // label="تكلفة العلاج"
                                type="number"
                                stylee={{ width: "100%" }}
                                value={illness.treatment_cost}
                                disabled
                              />
                            </td>
                            <td>
                              <RegisterTextbox
                                id={`notes-${illness.id}`}
                                // label="ملاحظات"
                                type="text"
                                stylee={{ width: "100%" }}
                                value={illness.notes}
                                disabled
                              />
                            </td>
                            <td>
                              <a
                                href={illness.attachment}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <FontAwesomeIcon icon={faEye} />
                              </a>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="6"
                            style={{
                              textAlign: "center",
                              fontSize: "20px",
                              color: "var(--text-color)",
                              margin: "20px",
                            }}
                          >
                            لا توجد أمراض
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </>
            </div>
          </>
        );
      case "dependentsdata":
        return (
          <>
            <div className="AddBeneficiary">
              <Title
                title="بيانات التابعين"
                icon={<FontAwesomeIcon icon={faPeopleRoof} />}
              />
              <div className="AddBeneficiaryContainer">
                {/* <span className='addillness' onClick={handleAddDependent}>
                                    <FontAwesomeIcon icon={faPlus} />
                                </span> */}
                <div
                  className="duplicatedContent"
                  style={{ marginTop: "50px" }}
                >
                  <table className="vac-custom-table">
                    <thead>
                      <tr className="vac-table-header selected-row">
                        <th>الأسم</th>
                        <th> الجنس</th>
                        <th> درجة القرابة</th>
                        <th> تارخ الميلاد</th>
                        <th> الجوال</th>
                        <th>ملاحظات</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows.dependants.length > 0 ? (
                        rows.dependants.map((dependants) => (
                          <tr key={dependants.id} className="selected-row">
                            <td>
                              <RegisterTextbox
                                id={`name-${dependants.id}`}
                                type="text"
                                stylee={{ width: "100%" }}
                                value={dependants.name}
                                disabled
                              />
                            </td>
                            <td>
                              <RegisterTextbox
                                id={`type-${dependants.id}`}
                                type="text"
                                stylee={{ width: "100%" }}
                                value={dependants.gender === 0 ? "ذكر" : "أنثى"}
                                disabled
                              />
                            </td>
                            <td>
                              <RegisterTextbox
                                id={`danger-${dependants.id}`}
                                type="text"
                                stylee={{ width: "100%" }}
                                value={dependants.relation}
                                disabled
                              />
                            </td>
                            <td>
                              <RegisterTextbox
                                id={`midtype-${dependants.id}`}
                                type="text"
                                stylee={{ width: "100%" }}
                                value={dependants.dateofbirth}
                                disabled
                              />
                            </td>
                            <td>
                              <RegisterTextbox
                                id={`cost-${dependants.id}`}
                                // label="تكلفة العلاج"
                                type="number"
                                stylee={{ width: "100%" }}
                                value={dependants.phone}
                                disabled
                              />
                            </td>
                            <td>
                              <RegisterTextbox
                                id={`notes-${dependants.id}`}
                                // label="ملاحظات"
                                type="text"
                                stylee={{ width: "100%" }}
                                value={dependants.note}
                                disabled
                              />
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="6"
                            style={{
                              textAlign: "center",
                              fontSize: "20px",
                              color: "var(--text-color)",
                              margin: "20px",
                            }}
                          >
                            لا يوجد أقارب
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </>
        );
      case "Decision":
        return (
          <>
            <div className="AddBeneficiary">
              <Title
                title="القرار"
                icon={<FontAwesomeIcon icon={faFileContract} />}
              />
              <div className="AddBeneficiaryContainer">
               {
                rows && rows.case && rows.case.status == 2 ? (
                  <h3 style={{ textAlign: "center", color: "green" }}>
                  تم قبول الحالة
                </h3>
                ) : (
                   <form
                  className="decisionForm"
                  style={{ width: "50%", margin: "auto" }}
                >
                  <RegisterSelect
                    label="القرار"
                    id="decision"
                    options={[
                      { value: "1", label: "قيد المراجعة" },
                      { value: "2", label: "موافقة" },
                      { value: "3", label: "رفض" },
                    ]}
                    value={decision}
                    onChange={(e) => setDecision(e.target.value)}
                    stylee={{ width: "100%" }}
                  />
                  {error && error.decision && (
                    <span className="error">{error.decision}</span>
                  )}
                  <RegisterTextarea
                    label="ملاحظات"
                    id="notes"
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    stylee={{ width: "100%" }}
                  />
                  {error && error.note && (
                    <span className="error">{error.note}</span>
                  )}
                  <div className="buttons">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleDecision}
                    >
                      حفظ
                    </button>
                  </div>
                </form>
                )
                
               }
              </div>
            </div>
          </>
        );
      default:
        return null;
    }
  };

  const renderAllContent = () => {
    return (
      <div>
        <>
          <div className="AddBeneficiary">
            <Title title="بيانات مستفيد" />
            <div className="AddBeneficiaryContainer">
              <div className="AddBeneficiaryContainerRow">
                <RegisterTextbox
                  parentStyle={{
                    width: "100%",
                  }}
                  id="benName"
                  label="إسم المستفيد"
                  type="text"
                  stylee={{
                    width: "100%",
                  }}
                  value={rows && rows.case && rows.case.name}
                  disabled
                />
                <RegisterSelect
                  id="fileStatus"
                  label="حالة المستفيد"
                  stylee={{ width: "40%" }}
                  parentStyle={{ width: "30%" }}
                  options={[
                    { value: "", label: "اختر الحالة" },
                    { value: "1", label: "مستفيد مؤقت" },
                    { value: "2", label: "مستفيد دائم" },
                  ]}
                  value={rows && rows.case && rows.case.type}
                  disabled
                />
              </div>

              <div className="AddBeneficiaryContainerRow">
                <RegisterTextbox
                  disabled={true}
                  parentStyle={{
                    width: "30%",
                  }}
                  id="createdBy"
                  label="انشأ بواسطة"
                  type="text"
                  stylee={{
                    width: "40%",
                  }}
                  value={
                    rows &&
                    rows.case &&
                    rows.case.details &&
                    rows.case.details.email
                  }
                  readOnly
                />{" "}
                <RegisterTextbox
                  parentStyle={{
                    width: "30%",
                  }}
                  id="updateDate"
                  label="تاريخ التحديث"
                  type="text"
                  stylee={{
                    width: "40%",
                  }}
                  value={
                    rows &&
                    rows.case &&
                    new Date(rows.case.updated_at).toISOString().substr(0, 10)
                  }
                  disabled
                />{" "}
              </div>
              <div className="AddBeneficiaryContainerRow">
                <RegisterTextbox
                  disabled={true}
                  parentStyle={{
                    width: "30%",
                  }}
                  id="happendby"
                  label="حدث بواسطة"
                  type="text"
                  stylee={{
                    width: "40%",
                  }}
                  value={
                    rows &&
                    rows.case &&
                    rows.case.details &&
                    rows.case.details.email
                  }
                  readOnly
                />{" "}
                <RegisterTextbox
                  parentStyle={{
                    width: "30%",
                  }}
                  id="createDate"
                  label="تاريخ الإنشاء"
                  type="text"
                  stylee={{
                    width: "40%",
                  }}
                  value={
                    rows &&
                    rows.case &&
                    new Date(rows.case.created_at).toISOString().substr(0, 10)
                  }
                  disabled
                />{" "}
              </div>
            </div>
          </div>
        </>

        <>
          <div className="AddBeneficiary">
            <Title title="البيانات الاساسية" />
            <div className="AddBeneficiaryContainer">
              <div className="AddBeneficiaryContainerRow">
                <RegisterTextbox
                  parentStyle={{
                    width: "20%",
                  }}
                  id="name"
                  label="الإسم"
                  type="text"
                  stylee={{
                    width: "40%",
                  }}
                  value={rows && rows.case && rows.case.name}
                  disabled
                />{" "}
                <RegisterSelect
                  id="sex"
                  label="النوع"
                  stylee={{ width: "30%" }}
                  parentStyle={{ width: "20%", marginBottom: "20px" }}
                  options={[
                    { value: "", label: "اختر النوع" },
                    { value: "0", label: "ذكر" },
                    { value: "1", label: "أنثي" },
                  ]}
                  value={rows && rows.case && rows.case.gender}
                  disabled
                />
              </div>
              <div className="AddBeneficiaryContainerRow">
                <RegisterTextbox
                  parentStyle={{ width: "20%" }}
                  id="dob"
                  label="تاريخ الميلاد"
                  type="text"
                  stylee={{ width: "40%" }}
                  value={rows && rows.case && rows.case.dateofbirth}
                  disabled
                />
                <RegisterSelect
                  id="relation"
                  label="الحالة الإجتماعية"
                  stylee={{ width: "30%" }}
                  parentStyle={{ width: "20%", marginBottom: "20px" }}
                  options={[
                    { value: "", label: "اختر الحالة الإجتماعية" },
                    { value: "0", label: "أعزب" },
                    { value: "1", label: "متزوج" },
                    { value: "2", label: "مطلق" },
                    { value: "3", label: "أرمل" },
                  ]}
                  value={rows && rows.case && rows.case && rows.case.status}
                  disabled
                />
              </div>
              <div className="AddBeneficiaryContainerRow">
                <RegisterTextbox
                  parentStyle={{
                    width: "20%",
                  }}
                  id="nationality"
                  label="الجنسية"
                  type="text"
                  stylee={{
                    width: "40%",
                  }}
                  value={
                    rows &&
                    rows.case &&
                    rows.case.details &&
                    rows.case.details.nationality
                  }
                />{" "}
                <RegisterTextbox
                  parentStyle={{
                    width: "20%",
                  }}
                  id="idnum"
                  label="رقم الهوية"
                  type="number"
                  stylee={{
                    width: "40%",
                  }}
                  value={
                    rows &&
                    rows.case &&
                    rows.case.details &&
                    rows.case.details.id_number
                  }
                  disabled
                />{" "}
              </div>
              <div className="AddBeneficiaryContainerRow">
                <RegisterTextbox
                  parentStyle={{
                    width: "20%",
                  }}
                  id="phoneNum"
                  label="رقم الجوال"
                  type="number"
                  stylee={{
                    width: "40%",
                  }}
                  value={
                    rows &&
                    rows.case &&
                    rows.case.details &&
                    rows.case.details.phone_number
                  }
                  disabled
                />{" "}
                <RegisterTextbox
                  parentStyle={{
                    width: "20%",
                  }}
                  id="email"
                  label="البريد الإلكتروني"
                  type="email"
                  stylee={{
                    width: "40%",
                  }}
                  value={
                    rows &&
                    rows.case &&
                    rows.case.details &&
                    rows.case.details.email
                  }
                  disabled
                />{" "}
              </div>
              <div className="AddBeneficiaryContainerRow">
                <RegisterTextbox
                  parentStyle={{
                    width: "20%",
                  }}
                  id="accNumber"
                  label="رقم الحساب"
                  type="text"
                  stylee={{
                    width: "40%",
                  }}
                  value={
                    rows &&
                    rows.case &&
                    rows.case.details &&
                    rows.case.details.account_number
                  }
                  disabled
                />{" "}
                <RegisterTextbox
                  parentStyle={{
                    width: "20%",
                  }}
                  id="idSource"
                  label="مصدر الهوية"
                  type="text"
                  stylee={{
                    width: "40%",
                  }}
                  value={
                    rows &&
                    rows.case &&
                    rows.case.details &&
                    rows.case.details.id_number
                  }
                  disabled
                />{" "}
              </div>
              <div className="AddBeneficiaryContainerRow">
                <RegisterTextbox
                  parentStyle={{
                    width: "20%",
                  }}
                  id="idDate"
                  label="تاريخ انتهاء الهوية"
                  type="text"
                  stylee={{
                    width: "40%",
                  }}
                  value={
                    rows &&
                    rows.case &&
                    rows.case.details &&
                    rows.case.details.id_expiration_date
                  }
                  disabled
                />{" "}
                <RegisterTextbox
                  parentStyle={{
                    width: "20%",
                  }}
                  id="moreNotes"
                  label="ملاحظات اضافية"
                  type="text"
                  stylee={{
                    width: "40%",
                  }}
                  value={
                    rows &&
                    rows.case &&
                    rows.case.details &&
                    rows.case.details.note
                  }
                  disabled
                />{" "}
              </div>
            </div>
          </div>
        </>

        <>
          <div className="AddBeneficiary">
            <Title title="البيانات البنكية" />
            <div className="AddBeneficiaryContainer">
              {rows &&
              rows.details &&
              rows.details.bankdetails !== null &&
              rows.details.bankdetails.length > 0 ? (
                <>
                  <div className="AddBeneficiaryContainerRow">
                    <RegisterTextbox
                      parentStyle={{
                        width: "30%",
                      }}
                      id="bankName"
                      label="إسم البنك"
                      type="text"
                      stylee={{
                        width: "40%",
                      }}
                      value={
                        rows &&
                        rows.details &&
                        rows.details.bankdetails &&
                        rows.details.bankdetails.length > 0
                          ? rows.details.bankdetails.name
                          : "لا يوجد بيانات حاليا"
                      }
                      disabled
                    />{" "}
                  </div>

                  <div className="AddBeneficiaryContainerRow">
                    <RegisterTextbox
                      parentStyle={{
                        width: "30%",
                      }}
                      id="branch"
                      label="الفرع"
                      type="text"
                      stylee={{
                        width: "40%",
                      }}
                      value={
                        rows &&
                        rows.details &&
                        rows.details.bankdetails &&
                        rows.details.bankdetails.branch
                          ? rows.details.bankdetails.branch
                          : "لا يوجد بيانات حاليا"
                      }
                      disabled
                    />{" "}
                  </div>
                  <div className="AddBeneficiaryContainerRow">
                    <RegisterTextbox
                      parentStyle={{
                        width: "30%",
                      }}
                      id="ibanNum"
                      label="رقم IBAN"
                      type="text"
                      stylee={{
                        width: "40%",
                      }}
                      value={
                        rows &&
                        rows.details &&
                        rows.details.bankdetails &&
                        rows.details.bankdetails.iban
                          ? rows.details.bankdetails.iban
                          : "لا يوجد بيانات حاليا"
                      }
                      disabled
                    />{" "}
                  </div>
                </>
              ) : (
                <>
                  <h3
                    style={{ textAlign: "center", color: "var(--text-color)" }}
                  >
                    لا يوجد بيانات حاليا
                  </h3>
                </>
              )}
            </div>
          </div>
        </>

        <>
          <div className="AddBeneficiary">
            <Title title="المؤهل والوظيفة" />
            {rows && rows.work_education !== null ? (
              <>
                <div className="AddBeneficiaryContainer">
                  <h3 style={{ marginRight: "10%" }}>المؤهلات والوظائف</h3>
                  <table
                    style={{
                      width: "80%",
                      margin: "auto",
                      direction: "rtl",
                      textAlign: "center",
                      borderCollapse: "collapse",
                      border: "1px solid var(--text-color)",
                      padding: "20px",
                    }}
                    className="styledTable"
                  >
                    <tr
                      style={{
                        border: "1px solid var(--text-color)",
                        margin: "20px",
                      }}
                    >
                      <th>المؤهل</th>
                      <th>الوظيفة</th>
                      <th>يستطيع العمل</th>
                    </tr>
                    <tr>
                      {/* we have to redesign this part */}
                      <td>
                        {rows &&
                          rows.work_education &&
                          rows.work_education.educationlevel}
                      </td>
                      <td>
                        {rows && rows.work_education && rows.work_education.job}
                      </td>
                      <td>
                        {rows &&
                        rows.work_education &&
                        rows.work_education.canwork == 0
                          ? "لا"
                          : "نعم"}
                      </td>
                    </tr>
                  </table>
                  <h3 style={{ marginRight: "10%" }}>الدخل</h3>
                  <table
                    style={{
                      width: "80%",
                      margin: "auto",
                      direction: "rtl",
                      textAlign: "center",
                      borderCollapse: "collapse",
                      border: "1px solid var(--text-color)",
                      padding: "20px",
                    }}
                    className="styledTable"
                  >
                    <tr
                      style={{
                        border: "1px solid var(--text-color)",
                        margin: "20px",
                      }}
                    >
                      <th>مصدر الدخل</th>
                      <th>الراتب</th>
                    </tr>
                    {rows &&
                    rows.work_education &&
                    rows.work_education.incomesource &&
                    rows.work_education.incomesource.length > 0 ? (
                      rows.work_education.incomesource.map((income, index) => (
                        <tr key={index}>
                          <td>{income.name}</td>
                          <td>{income.amount}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="2"
                          style={{
                            textAlign: "center",
                            fontSize: "20px",
                            color: "var(--text-color)",
                            margin: "20px",
                          }}
                        >
                          لا يوجد بيانات حاليا
                        </td>
                      </tr>
                    )}
                  </table>
                  <h3 style={{ marginRight: "10%" }}>الدورات التدريبية</h3>
                  <table
                    style={{
                      width: "80%",
                      margin: "auto",
                      direction: "rtl",
                      textAlign: "center",
                      borderCollapse: "collapse",
                      border: "1px solid var(--text-color)",
                      padding: "20px",
                    }}
                    className="styledTable"
                  >
                    <tr
                      style={{
                        border: "1px solid var(--text-color)",
                        margin: "20px",
                      }}
                    >
                      <th>اسم الدورة</th>
                      <th>مكان الحصول عليها</th>
                    </tr>

                    {rows &&
                    rows.work_education &&
                    rows.work_education.courses &&
                    rows.work_education.courses.length > 0 ? (
                      rows.work_education.courses.map((training, index) => (
                        <tr key={index}>
                          <td>{training.title}</td>
                          <td>{training.address}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="2"
                          style={{
                            textAlign: "center",
                            fontSize: "20px",
                            color: "var(--text-color)",
                            margin: "20px",
                          }}
                        >
                          لا يوجد بيانات حاليا
                        </td>
                      </tr>
                    )}
                  </table>
                </div>
              </>
            ) : (
              <>
                <h3 style={{ textAlign: "center", color: "var(--text-color)" }}>
                  لا يوجد بيانات حاليا
                </h3>
              </>
            )}
          </div>
        </>

        <>
          <div className="AddBeneficiary">
            <Title title="بيانات السكن" />
            {rows &&
            rows.details &&
            rows.details.personalfeesdetails &&
            rows.details.personalfeesdetails.length > 0 ? (
              <>
                <div className="AddBeneficiaryContainerRow ">
                  <RegisterTextbox
                    parentStyle={{
                      width: "30%",
                    }}
                    id="state"
                    label="القطاع (المحافظة)"
                    type="text"
                    stylee={{
                      width: "40%",
                    }}
                    value={
                      rows &&
                      rows.details &&
                      rows.details.personalfeesdetails &&
                      rows.details.personalfeesdetails.state
                    }
                    disabled
                  />{" "}
                  <RegisterTextbox
                    parentStyle={{
                      width: "30%",
                    }}
                    id="village"
                    label="القرية (الحي)"
                    type="text"
                    stylee={{
                      width: "40%",
                    }}
                    value={
                      rows &&
                      rows.details &&
                      rows.details.personalfeesdetails &&
                      rows.details.personalfeesdetails.village
                    }
                    disabled
                  />{" "}
                </div>
                <div className="AddBeneficiaryContainerRow">
                  <RegisterTextbox
                    parentStyle={{
                      width: "30%",
                    }}
                    id="nationalAdress"
                    label="العنوان الوطني"
                    type="text"
                    stylee={{
                      width: "40%",
                    }}
                    value={
                      rows &&
                      rows.details.personalfeesdetails &&
                      rows.details.personalfeesdetails.nationalAddress
                    }
                    disabled
                  />{" "}
                  <RegisterTextbox
                    parentStyle={{
                      width: "30%",
                    }}
                    id="summaryadress"
                    label="العنوان المختصر"
                    type="text"
                    stylee={{
                      width: "40%",
                    }}
                    value={
                      rows &&
                      rows.details.personalfeesdetails &&
                      rows.details.personalfeesdetails.summaryAdDress
                    }
                    disabled
                  />{" "}
                </div>
                <div className="AddBeneficiaryContainerRow">
                  <RegisterTextbox
                    parentStyle={{
                      width: "30%",
                    }}
                    id="summaryadress"
                    label="نوع السكن "
                    type="text"
                    stylee={{
                      width: "40%",
                    }}
                    value={
                      rows &&
                      rows.details.personalfeesdetails &&
                      rows.details.personalfeesdetails.homeType
                    }
                    disabled
                  />
                  <RegisterTextbox
                    parentStyle={{
                      width: "30%",
                    }}
                    id="ownership"
                    label="ملكية السكن"
                    type="text"
                    stylee={{
                      width: "40%",
                    }}
                    value={
                      rows &&
                      rows.details.personalfeesdetails &&
                      rows.details.personalfeesdetails.homeOwnership
                    }
                    disabled
                  />
                </div>
                <div className="AddBeneficiaryContainerRow">
                  <RegisterTextbox
                    parentStyle={{
                      width: "30%",
                    }}
                    id="month"
                    label="الإيجار الشهري للسكن"
                    type="number"
                    stylee={{
                      width: "40%",
                    }}
                    value={
                      rows &&
                      rows.details.personalfeesdetails &&
                      rows.details.personalfeesdetails.rent
                    }
                    disabled
                  />
                  <RegisterTextbox
                    parentStyle={{
                      width: "30%",
                    }}
                    id="cars"
                    label="عدد السيارات المملوكة"
                    type="number"
                    stylee={{
                      width: "40%",
                    }}
                    value={
                      rows &&
                      rows.details.personalfeesdetails &&
                      rows.details.personalfeesdetails.cars
                    }
                    disabled
                  />
                </div>

                <div className="AddBeneficiaryContainerRow">
                  <RegisterTextbox
                    parentStyle={{
                      width: "30%",
                    }}
                    id="lands"
                    label="عدد الأراضي المملوكة"
                    type="number"
                    stylee={{
                      width: "40%",
                    }}
                    value={
                      rows &&
                      rows.details.personalfeesdetails &&
                      rows.details.personalfeesdetails.lands
                    }
                    disabled
                  />
                  <RegisterTextbox
                    parentStyle={{
                      width: "30%",
                    }}
                    id="components"
                    label="مكونات السكن"
                    type="text"
                    stylee={{
                      width: "40%",
                    }}
                    value={
                      rows &&
                      rows.details.personalfeesdetails &&
                      rows.details.personalfeesdetails.components
                    }
                    disabled
                  />
                </div>
                <div className="AddBeneficiaryContainerRow">
                  <RegisterTextbox
                    parentStyle={{
                      width: "30%",
                    }}
                    id="furniture"
                    label="اثاث الشقة"
                    type="text"
                    stylee={{
                      width: "40%",
                    }}
                    value={
                      rows &&
                      rows.details.personalfeesdetails &&
                      rows.details.personalfeesdetails.furniture
                    }
                    disabled
                  />
                  <RegisterTextbox
                    parentStyle={{
                      width: "30%",
                    }}
                    id="personperMonth"
                    label="تكاليف الشهر للفرد"
                    type="text"
                    stylee={{
                      width: "40%",
                    }}
                    value={
                      rows &&
                      rows.details.personalfeesdetails &&
                      rows.details.personalfeesdetails.cost
                    }
                    disabled
                  />
                </div>

                <h3 style={{ direction: "rtl", marginRight: "12%" }}>
                  {" "}
                  مصروفات السكن{" "}
                </h3>
                <table
                  style={{
                    width: "75%",
                    margin: "auto",
                    direction: "rtl",
                    textAlign: "center",
                    borderCollapse: "collapse",
                    border: "1px solid var(--text-color)",
                    padding: "20px",
                  }}
                  className="styledTable"
                >
                  <tr
                    style={{
                      border: "1px solid var(--text-color)",
                      margin: "20px",
                    }}
                  >
                    <th> الفاتورة الشهرية</th>
                    <th>القيمة</th>
                  </tr>

                  {rows &&
                  rows.details.personalfeesdetails &&
                  JSON.parse(rows.details.personalfeesdetails.bill) &&
                  JSON.parse(rows.details.personalfeesdetails.bill).length >
                    0 ? (
                    JSON.parse(rows.details.personalfeesdetails.bill).map(
                      (bill, index) => (
                        <tr key={index}>
                          <td>{bill.bill}</td>
                          <td>{bill.amount}</td>
                        </tr>
                      )
                    )
                  ) : (
                    <tr>
                      <td
                        colSpan="2"
                        style={{
                          textAlign: "center",
                          fontSize: "20px",
                          color: "var(--text-color)",
                          margin: "20px",
                        }}
                      >
                        لا يوجد بيانات حاليا
                      </td>
                    </tr>
                  )}
                </table>
              </>
            ) : (
              <div className="message-container">
                <p
                  style={{
                    textAlign: "center",
                    fontSize: "25px",
                    color: "red",
                    margin: "30px",
                  }}
                >
                  لا يوجد تفاصيل لعرضها
                </p>
              </div>
            )}
          </div>
        </>

        <>
          <div className="AddBeneficiary">
            <Title title="البيانات الصحية" />
            <>
              <div className="duplicatedContent">
                <table className="vac-custom-table">
                  <thead>
                    <tr className="vac-table-header selected-row">
                      <th>اسم المرض</th>
                      <th>نوع المرض</th>
                      <th>خطورة المرض</th>
                      <th>نوع العلاج</th>
                      <th>تكلفة العلاج</th>
                      <th>ملاحظات</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.health.length > 0 ? (
                      rows.health.map((illness) => (
                        <tr key={illness.id} className="selected-row">
                          <td>
                            <RegisterTextbox
                              id={`name-${illness.id}`}
                              type="text"
                              stylee={{ width: "100%" }}
                              value={illness.disease_name}
                              disabled
                            />
                          </td>
                          <td>
                            <RegisterTextbox
                              id={`type-${illness.id}`}
                              // label="نوع المرض"
                              type="text"
                              stylee={{ width: "100%" }}
                              value={illness.disease_type}
                              disabled
                            />
                          </td>
                          <td>
                            <RegisterTextbox
                              id={`danger-${illness.id}`}
                              // label="خطورة المرض"
                              type="text"
                              stylee={{ width: "100%" }}
                              value={illness.disease_degree}
                              disabled
                            />
                          </td>
                          <td>
                            <RegisterTextbox
                              id={`midtype-${illness.id}`}
                              // label="نوع العلاج"
                              type="text"
                              stylee={{ width: "100%" }}
                              value={illness.treatment_type}
                              disabled
                            />
                          </td>
                          <td>
                            <RegisterTextbox
                              id={`cost-${illness.id}`}
                              // label="تكلفة العلاج"
                              type="number"
                              stylee={{ width: "100%" }}
                              value={illness.treatment_cost}
                              disabled
                            />
                          </td>
                          <td>
                            <RegisterTextbox
                              id={`notes-${illness.id}`}
                              // label="ملاحظات"
                              type="text"
                              stylee={{ width: "100%" }}
                              value={illness.notes}
                              disabled
                            />
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="6"
                          style={{
                            textAlign: "center",
                            fontSize: "20px",
                            color: "var(--text-color)",
                            margin: "20px",
                          }}
                        >
                          لا توجد أمراض
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </>
          </div>
        </>

        <>
          <div className="AddBeneficiary">
            <Title title="بيانات التابعين" />
            <div className="AddBeneficiaryContainer">
              {/* <span className='addillness' onClick={handleAddDependent}>
                                <FontAwesomeIcon icon={faPlus} />
                            </span> */}
              <div className="duplicatedContent">
                <table className="vac-custom-table">
                  <thead>
                    <tr className="vac-table-header selected-row">
                      <th>الأسم</th>
                      <th> الجنس</th>
                      <th> درجة القرابة</th>
                      <th> تارخ الميلاد</th>
                      <th> الجوال</th>
                      <th>ملاحظات</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.dependants.length > 0 ? (
                      rows.dependants.map((dependants) => (
                        <tr key={dependants.id} className="selected-row">
                          <td>
                            <RegisterTextbox
                              id={`name-${dependants.id}`}
                              type="text"
                              stylee={{ width: "100%" }}
                              value={dependants.name}
                              disabled
                            />
                          </td>
                          <td>
                            <RegisterTextbox
                              id={`type-${dependants.id}`}
                              type="text"
                              stylee={{ width: "100%" }}
                              value={dependants.gender === 0 ? "ذكر" : "أنثى"}
                              disabled
                            />
                          </td>
                          <td>
                            <RegisterTextbox
                              id={`danger-${dependants.id}`}
                              type="text"
                              stylee={{ width: "100%" }}
                              value={dependants.relation}
                              disabled
                            />
                          </td>
                          <td>
                            <RegisterTextbox
                              id={`midtype-${dependants.id}`}
                              type="text"
                              stylee={{ width: "100%" }}
                              value={dependants.dateofbirth}
                              disabled
                            />
                          </td>
                          <td>
                            <RegisterTextbox
                              id={`cost-${dependants.id}`}
                              // label="تكلفة العلاج"
                              type="number"
                              stylee={{ width: "100%" }}
                              value={dependants.phone}
                              disabled
                            />
                          </td>
                          <td>
                            <RegisterTextbox
                              id={`notes-${dependants.id}`}
                              // label="ملاحظات"
                              type="text"
                              stylee={{ width: "100%" }}
                              value={dependants.note}
                              disabled
                            />
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="6"
                          style={{
                            textAlign: "center",
                            fontSize: "20px",
                            color: "var(--text-color)",
                            margin: "20px",
                          }}
                        >
                          لا يوجد أقارب
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </>
      </div>
    );
  };

  // New
  const handleFullPrint = (e) => {
    e.preventDefault();
    const printContents = document.getElementById("printSection").innerHTML;
    
    // console.log("Clicked");
    let oldHtml = document.body.innerHTML;
  let printable =(`
        <html>
        <head>
            <title>طباعة</title>

            <style>
            body {
                direction: rtl;
                font-family: 'Segoe UI', Tahoma, Arial, sans-serif;
                margin: 0;
                padding: 20px;
                background-color: #f5f7fa;
                color: #1f1f1f;
            }

            .AddBeneficiary {
                border: 1px solid #dce3ea;
                border-radius: 10px;
                margin-bottom: 30px;
                padding: 20px;
                background-color: #ffffff;
                box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
                transition: box-shadow 0.3s ease;
            }

            .AddBeneficiary:hover {
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
            }

            .Title h2, .Title h3 {
                font-size: 18pt;
                color: #0b4f7b;
                background-color: #eaf1f7;
                padding: 15px 20px;
                margin: -20px -20px 25px -20px;
                border-bottom: 2px solid #0b4f7b;
                border-radius: 10px 10px 0 0;
                text-align: right;
            }

            h3 {
                font-size: 14pt;
                color: #2c3e50;
                border-bottom: 1px solid #dcdcdc;
                padding-bottom: 10px;
                margin-top: 30px;
                margin-bottom: 20px;
            }

            .AddBeneficiaryContainerRow {
                width: 800px;
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
                gap: 20px;
                margin-bottom: 16px;
            }

            .register-textbox-parent, .register-select-parent {
                flex: 1;
                min-width: 260px;
                background-color: #f9fafa;
                border: 1px solid #dfe6ec;
                border-radius: 6px;
                padding: 10px 14px;
            }

            .register-textbox-parent label, .register-select-parent label {
                display: block;
                font-size: 11pt;
                font-weight: bold;
                color: #333;
                margin-bottom: 6px;
            }

            input, select {
                width: 100% !important;
                border: none !important;
                background-color: transparent !important;
                padding: 4px 0 !important;
                font-size: 13pt !important;
                color: #000 !important;
                font-family: inherit !important;
                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;
            }

            select {
                pointer-events: none;
            }

            .styledTable, .vac-custom-table {
                width: 100%;
                margin: 20px 0;
                border-collapse: collapse;
                font-size: 11pt;
                background-color: #fff;
                box-shadow: 0 0 6px rgba(0, 0, 0, 0.05);
            }

            .styledTable th, .vac-custom-table th,
            .styledTable td, .vac-custom-table td {
                border: 1px solid #dee2e6;
                padding: 12px 10px;
                text-align: right;
                vertical-align: middle;
            }

            .styledTable thead, .vac-custom-table thead {
                background-color: #f1f5f9;
            }

            .styledTable th, .vac-custom-table th {
                font-weight: bold;
                color: #343a40;
            }

            .vac-custom-table td input {
                margin: -10px;
                padding: 10px !important;
            }

            .no-print {
                display: none !important;
            }
            @media print {

  /* علشان أي عنصر كبير (زي .AddBeneficiary أو table) مايتقطعش بين صفحتين */
  .AddBeneficiary, 
  .styledTable, 
  .vac-custom-table, 
  .AddBeneficiaryContainerRow {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  /* لما عنصر جديد يبدأ، يبدأ في صفحة جديدة لو الصفحة الحالية قربت تخلص */
  h3, .Title {
    page-break-before: auto;
    break-before: auto;
  }

  /* تأكد إن كل عناصر الطباعة بتتظبط بشكل حلو */
  body {
    background: white;
    margin: 0;
  }

  /* خلى كل العناصر اللي فيها محتوى متداخل تلف تلقائي لو اتقطعت */
  table, div, section {
    overflow: visible !important;
  }

  /* لو عندك محتوى كبير جدًا ممكن يتكسر */
  tr, td, th {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  /* ما تخليش الجدول يتقطع في النص */
  table {
    page-break-after: auto;
  }

}


        </style>


        </head>
        <body>${printContents}</body>
        </html>
    `);
    document.body.innerHTML = printable;
    window.print();
    document.body.innerHTML = oldHtml;
  };

  return loading ? (
    <>
      <TestPreLoader />{" "}
    </>
  ) : (
    <>
      <div id="printSection" style={{ display: "none" }}>
        {renderAllContent()}
      </div>

      <div className="createloan">
        <form>
          <div className="divre">
            <div className="myTabs myTabs2" style={{ direction: "rtl" }}>
              {tabs.map((tab) => (
                <button
                  key={tab}
                  className={`loantab ${
                    activeTab === tab ? "active" : ""
                  } loantab2`}
                  onClick={() => setActiveTab(tab)}
                  type="button"
                >
                  {tab === "beneficiary"
                    ? "1"
                    : tab === "mainbeneficiarydata"
                    ? "2"
                    : tab === "bankdata"
                    ? "3"
                    : tab === "qualificationposition"
                    ? "4"
                    : tab === "housingdata"
                    ? "5"
                    : tab === "healthdata"
                    ? "6"
                    : tab === "dependentsdata"
                    ? "7"
                    : tab === "Decision"
                    ? "8"
                    : ""}
                </button>
              ))}
            </div>
            <div className="line"></div>
          </div>
          <div className="tabContent">{renderContent()}</div>

          <div className="navigationButtons">
            {activeTab !== "Decision" ? (
              <button
                className=" loanbtn nextButton"
                onClick={handleNext}
                disabled={tabs.indexOf(activeTab) === tabs.length - 1}
                type="button"
              >
                التالي
              </button>
            ) : (
              <p></p>
            )}
            {activeTab !== "beneficiary" && (
              <button
                className=" loanbtn backButton"
                onClick={handleBack}
                type="button"
              >
                السابق
              </button>
            )}
            {activeTab === "Decision" && (
              <button
                className="loanbtn submitButton"
                type="button"
                onClick={handleFullPrint}
              >
                طباعة
              </button>
            )}
          </div>
        </form>
      </div>
    </>
  );
}

export default CaseStudy;
